import React from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import Edit from "./edit";
import PropTypes from "prop-types";
export default function CreateIssue(props) {
  let { vendors, assessment, risk, analyst, handleBack, reload,priorityList,SetTab } = props;
  return (
    <div className="">
      <Edit
        mode={"create"}
        reload={reload}
        vendors={vendors}
        assessment={assessment}
        risk={risk}
        analyst={analyst}
        handleBack={handleBack}
        priorityList={priorityList}
        SetTabIssue={SetTab}
      />
    </div>
  );
}

CreateIssue.propTypes = {
  vendors: PropTypes.any, 
  assessment: PropTypes.any, 
  risk: PropTypes.any, 
  analyst: PropTypes.any, 
  handleBack: PropTypes.any, 
  reload: PropTypes.any,
  priorityList: PropTypes.any,
  SetTab: PropTypes.any
}
